import { api } from '@/api'
import qs from 'qs'

import { WeatherEventPatchParam, WeatherWorkEventParams } from '@/use/weather-works'

export default {
  get: ({ include, q, page, perPage, tripId, scope }: WeatherWorkEventParams) => {
    return api.$get(`/trips/${tripId}/storm_details`, {
      params: {
        include,
        q,
        page,
        per_page: perPage,
        scope
      },
      paramsSerializer: params => {
        return qs.stringify(params)
      }
    })
  },
  associateTrip: (stormDetailId: number|string, params: WeatherEventPatchParam) => {
    return api.$patch(`/trips/${params.tripId}/storm_details/${stormDetailId}/associate_trip`, params)
  }
}
